<div mat-dialog-content style="font-size: 16px; margin-bottom: 20px">
  {{ (isRequestToStart ? 'WEBCLIENT.CHATROOM.VIDEO_CALL.START_CALL_CONFIRM_MSG' : 'WEBCLIENT.CHATROOM.VIDEO_CALL.END_CALL_CONFIRM_MSG') | translate }}
</div>
<div class="prompt-btns-wrapper">
  <button mat-button mat-dialog-close style="background-color: #eee; margin-right: 5px">{{ 'GENERAL.CANCEL' | translate }}</button>
  <button mat-button mat-dialog-close *ngIf="isRequestToStart" (click)="startVideoCallSession()">{{ 'GENERAL.CONFIRM' | translate }}</button>
  <button mat-button mat-dialog-close *ngIf="!isRequestToStart" (click)="stopVideoCallSession()">{{ 'GENERAL.CONFIRM' | translate }}</button>
</div>
